import { render, staticRenderFns } from "./insurePaySuccess.vue?vue&type=template&id=0c3435d0&scoped=true"
import script from "./insurePaySuccess.vue?vue&type=script&lang=js"
export * from "./insurePaySuccess.vue?vue&type=script&lang=js"
import style0 from "./insurePaySuccess.vue?vue&type=style&index=0&id=0c3435d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3435d0",
  null
  
)

export default component.exports